module.exports = __webpack_public_path__ + "static/media/main idea.14e7a6d4.mp3";